import { Box, Container, Grid, Link, Stack, Typography } from "@mui/material";
import useResponsive from "../../../hooks/useResponsive";
import { SeasonSwitch } from "../../SeasonSwitch";
import { useFormContext } from "react-hook-form";
import { FirstStepFormData } from "../../../schemas/validationSchemas";
import { FormCheckbox, FormMonthSelector } from "../../common";

export const TemperatureBox = () => {
  const { control, watch } = useFormContext<FirstStepFormData>();
  const { isSm, isXs, isMd, isLg } = useResponsive();
  const isMobile = isSm || isXs;
  const isTablet = isMd || isLg;

  const temperatureData = watch("temperatureData") || {};

  const marginTop = 4;

  return (
    <Box px={2} py={6}>
      <Container>
        <Typography textAlign={"center"}></Typography>
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          flexDirection={"column"}
        >
          <Typography
            variant="body1"
            fontSize={24}
            textAlign={isMobile ? "start" : "center"}
          >
            Select the operating period for the heat pump
          </Typography>
          <SeasonSwitch />
          <Typography
            mt={isMobile ? 4 : isTablet ? 4 : 10}
            variant="body1"
            fontSize={16}
          >
            Average temperature for this location
          </Typography>
          <Grid
            mt={marginTop}
            container
            direction={"row"}
            justifyContent={"center"}
            flexDirection={"row"}
            gap={1}
          >
            <FormMonthSelector
              name="operatingMonths"
              control={control}
              temperatureData={temperatureData as Record<number, number>}
            />
          </Grid>
        </Box>
        <Stack
          mt={10}
          display={"flex"}
          flexDirection={"row"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <FormCheckbox
            name="termsAccepted"
            control={control}
            label={
              <>
                I understand the information provided is voluntary and may be
                used to verify my details so that Davey Customer Service is able
                to attend to my enquiry{" "}
                <Link href="https://daveywater.com/au/privacy-policy/">
                  (Privacy Policy)
                </Link>
              </>
            }
          />
        </Stack>
      </Container>
    </Box>
  );
};
